var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/gift-card/product-gift-card-message.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/form-validation.j2", false, "product/templates/gift-card/product-gift-card-message.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("hasErrors")) {
var t_4 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_4);
var t_5;
t_5 = (runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isEgiftCard")?"eGiftMessageLength":"giftMessageLength");
frame.set("optionKey", t_5, true);
if(frame.topLevel) {
context.setVariable("optionKey", t_5);
}
if(frame.topLevel) {
context.addExport("optionKey", t_5);
}
var t_6;
t_6 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"browseDisplayOptions")),runtime.contextOrFrameLookup(context, frame, "optionKey"));
frame.set("maxLength", t_6, true);
if(frame.topLevel) {
context.setVariable("maxLength", t_6);
}
if(frame.topLevel) {
context.addExport("maxLength", t_6);
}
output += "<div class=\"c-form__field ";
output += runtime.suppressValue((lineno = 6, colno = 36, runtime.callWrap(t_4, "hasErrors", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productControls")),"validation")),"messages")),"message")])), env.opts.autoescape);
output += "\">\n\n    <label class=\"c-form__label\" for=\"gift-message\">";
output += runtime.suppressValue((lineno = 8, colno = 54, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_gift-card-message"])), env.opts.autoescape);
output += "</label>\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "quickshop") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"product")),"productControls")),"validation")),"values")),"message")) {
output += "\n        ";
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"product")),"productControls")),"validation")),"values")),"message");
frame.set("recipientMessage", t_7, true);
if(frame.topLevel) {
context.setVariable("recipientMessage", t_7);
}
if(frame.topLevel) {
context.addExport("recipientMessage", t_7);
}
output += "\n    ";
;
}
else {
output += "\n        ";
var t_8;
t_8 = "";
frame.set("recipientMessage", t_8, true);
if(frame.topLevel) {
context.setVariable("recipientMessage", t_8);
}
if(frame.topLevel) {
context.addExport("recipientMessage", t_8);
}
output += "\n    ";
;
}
output += "\n\n    <textarea id=\"gift-message\" name=\"message\" class=\"c-form__textarea js-form-textarea js-textarea js-gift-message-textarea\" maxlength=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "maxLength"), env.opts.autoescape);
output += "\" placeholder=\"";
output += runtime.suppressValue((lineno = 16, colno = 164, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_gc-message"])), env.opts.autoescape);
output += "\" data-qa-gift-message data-max-count=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "maxLength"), env.opts.autoescape);
output += "\" aria-labelledby=\"gift-message-hint\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "recipientMessage"), env.opts.autoescape);
output += "</textarea>\n\n    <div class=\"o-row\">\n\n        ";
output += "\n        <div class=\"o-column o-extra-small--12 u-no-gutters c-form__hint c-form__textarea-remain js-textarea-remain\" data-qa-gift-message-remainder></div>\n\n    </div>\n    \n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/gift-card/product-gift-card-message.j2"] , dependencies)